import MyEvent from '@/assets/js/myevent';

// Components
import Header from '@/assets/js/components/header';
import Pagetop from '@/assets/js/components/pagetop';

// Pages
import Index from '@/assets/js/pages/index';

const bodyId = $('body').attr('id');
const pages = {
  index: Index,
};

const myEvent = MyEvent();

Header();
Pagetop();
smoothScroll();

// 各ページ用のjs実行
if (pages[bodyId]) {
  pages[bodyId](bodyId);
}

// スムーススクロール
function smoothScroll() {
  $('a[href*="#"]')
    .on('click', function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        const $target = $(this.hash);
        if ($target.length) {
          let scrollTop = $target.offset().top;
          if (myEvent.getMediaQuery().current === 'sm') {
            scrollTop -= 50;
          } else {
            scrollTop -= 80;
          }
          $('html, body').stop().animate({ scrollTop: scrollTop }, 500, 'swing');
        }
        return false;
      }
    });
}
